<!--
 * @Desc: 答案模板
 * @Author: hedahai
 * @Date: 2020-10-21 16:55:07
-->
<template>
  <div class="answer-form">
    <el-form :inline="true"
             :disabled="submitStatus === 2"
             ref="formAgent12"
             :model="form['formAgent12']"
             v-if="answerType === 'formAgent12'"
             :rules="rules['formAgent12']">
      <el-form-item prop="text">
        <el-input v-model="form['formAgent12'].text"
                  style="width:800px"
                  :rows="5"
                  :maxlength="600"
                  type="textarea" :placeholder="textAreaPlaceHolder"></el-input>
      </el-form-item>
    </el-form>
    <el-form :inline="true"
             :disabled="submitStatus === 2"
             ref="formAgent"
             :model="form['formAgent']"
             v-if="answerType === 'formAgent'"
             :rules="rules['formAgent']">
      <el-form-item v-if="isRespondent"
                    prop="agreeApplicant"
                    label="是否同意申请人回答内容">
        <el-radio-group v-model="form['formAgent'].agreeApplicant"
                        style="width: 200px">
          <el-radio :label="'1'">是</el-radio>
          <el-radio :label="'0'">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="text"
                    v-if="form['formAgent'].agreeApplicant === '0'">
        <el-input v-model="form['formAgent'].text"
                  style="width:800px"
                  :rows="5"
                  :maxlength="600"
                  type="textarea" :placeholder="textAreaPlaceHolder"></el-input>
      </el-form-item>
    </el-form>
    <!-- 常规模板form0 -->
    <el-form :inline="true"
             :disabled="submitStatus === 2"
             ref="form0"
             :model="form['form0']"
             v-if="answerType === 'form0'"
             :rules="rules['form0']">
      <el-form-item v-if="isRespondent"
                    prop="agreeApplicant"
                    label="是否同意申请人回答内容">
        <el-radio-group v-model="form['form0'].agreeApplicant"
                        style="width: 200px">
          <el-radio :label="'1'">是</el-radio>
          <el-radio :label="'0'">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="text"
                    v-if="form['form0'].agreeApplicant === '0'">
        <el-input v-model="form['form0'].text"
                  style="width:800px"
                  :rows="5"
                  :maxlength="600"
                  type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <!-- 最后陈述意见 -->
    <el-form :inline="true"
             :disabled="submitStatus === 2"
             ref="form20"
             :model="form['form20']"
             v-if="answerType === 'form20'"
             :rules="rules['form20']">
      <el-form-item prop="text">
        <el-input v-model="form['form20'].text"
                  style="width:800px"
                  :rows="5"
                  :maxlength="600"
                  type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <!-- --------入职时间？工作岗位？--------- -->
    <el-form :inline="true"
             :disabled="submitStatus === 2"
             ref="form1"
             :model="form['form1']"
             :rules="rules['form1']"
             v-if="answerType === 'form1'">
      <el-form-item v-if="isRespondent"
                    prop="agreeApplicant"
                    label="是否同意申请人回答内容">
        <el-radio-group v-model="form['form1'].agreeApplicant"
                        style="width: 200px">
          <el-radio :label="'1'">是</el-radio>
          <el-radio :label="'0'">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form['form1'].agreeApplicant === '0'">
        <el-form-item prop="time"
                      label="入职时间">
          <el-date-picker type="date"
                          placeholder="选择日期"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          v-model="form['form1'].time"
                          style="width:180px"></el-date-picker>
        </el-form-item>
        <el-form-item label="工作岗位是"
                      prop="position">
          <el-input v-model="form['form1'].position"
                    :maxlength="600"
                    style="width:530px"></el-input>
        </el-form-item>
      </el-form-item>
    </el-form>
    <!-- ---------签订劳动合同情况？--------- -->
    <el-form ref="form2"
             :disabled="submitStatus === 2"
             :model="form['form2']"
             :rules="rules['form2']"
             v-if="answerType === 'form2'">
      <el-form-item v-if="isRespondent"
                    prop="agreeApplicant"
                    label="是否同意申请人回答内容">
        <el-radio-group v-model="form['form2'].agreeApplicant"
                        style="width: 200px">
          <el-radio :label="'1'">是</el-radio>
          <el-radio :label="'0'">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="code"
                    v-if="form['form2'].agreeApplicant === '0'">
        <el-select v-model="form['form2'].code"
                   placeholder="请选择"
                   style="width:180px">
          <el-option v-for="item in laborContractList"
                     :key="item.code"
                     :label="item.title"
                     :value="item.code"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <!-- ---------工资何时、何形式发放？--------- -->
    <el-form :inline="true"
             :disabled="submitStatus === 2"
             ref="form4"
             :rules="rules['form4']"
             :model="form['form4']"
             v-if="answerType === 'form4'">
      <el-form-item v-if="isRespondent"
                    prop="agreeApplicant"
                    label="是否同意申请人回答内容">
        <el-radio-group v-model="form['form4'].agreeApplicant"
                        style="width: 200px">
          <el-radio :label="'1'">是</el-radio>
          <el-radio :label="'0'">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form['form4'].agreeApplicant === '0'">
        <el-form-item label="每月"
                      prop="dayCode">
          <el-select v-model="form['form4'].dayCode"
                     placeholder="请选择"
                     style="width:100px">
            <el-option v-for="item in dayList"
                       :key="item"
                       :label="item"
                       :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日以"
                      prop="transferMoneyCode">
          <el-select v-model="form['form4'].transferMoneyCode"
                     placeholder="请选择"
                     style="width:160px">
            <el-option v-for="item in transferMoneyList"
                       :key="item.code"
                       :label="item.title"
                       :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="形式发放"
                      prop="monthCode">
          <el-select v-model="form['form4'].monthCode"
                     placeholder="请选择"
                     style="width:140px">
            <el-option v-for="item in monthList"
                       :key="item.code"
                       :label="item.title"
                       :value="item.code"></el-option>
          </el-select>
          工资。
        </el-form-item>
      </el-form-item>
    </el-form>
    <!-- ---------发放工资是否有工资清单？是否需要签收？--------- -->
    <el-form :inline="true"
             :disabled="submitStatus === 2"
             ref="form5"
             :rules="rules['form5']"
             :model="form['form5']"
             v-if="answerType === 'form5'">
      <el-form-item v-if="isRespondent"
                    prop="agreeApplicant"
                    label="是否同意申请人回答内容">
        <el-radio-group v-model="form['form5'].agreeApplicant"
                        style="width: 200px">
          <el-radio :label="'1'">是</el-radio>
          <el-radio :label="'0'">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form['form5'].agreeApplicant === '0'">
        <el-form-item label="是否有工资清单："
                      prop="salary">
          <el-radio-group v-model="form['form5'].salary"
                          style="width: 200px">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否需要签收："
                      prop="sign">
          <el-radio-group v-model="form['form5'].sign">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form-item>
    </el-form>
    <!-- ---------工作时间？--------- -->
    <el-form :inline="true"
             :disabled="submitStatus === 2"
             ref="form6"
             :rules="rules['form6']"
             :model="form['form6']"
             v-if="answerType === 'form6'">
      <el-form-item v-if="isRespondent"
                    prop="agreeApplicant"
                    label="是否同意申请人回答内容">
        <el-radio-group v-model="form['form6'].agreeApplicant"
                        style="width: 200px">
          <el-radio :label="'1'">是</el-radio>
          <el-radio :label="'0'">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form['form6'].agreeApplicant === '0'">
        <el-form-item label="早上"
                      prop="upWork">
          <el-select v-model="form['form6'].upWork"
                     placeholder="请选择"
                     style="width:100px">
            <el-option v-for="item in hourList"
                       :key="item"
                       :label="item"
                       :value="item"></el-option>
          </el-select>
          点上班，
        </el-form-item>
        <el-form-item label="下午"
                      prop="downWork">
          <el-select v-model="form['form6'].downWork"
                     placeholder="请选择"
                     style="width:100px">
            <el-option v-for="item in hourList"
                       :key="item"
                       :label="item"
                       :value="item"></el-option>
          </el-select>
          点下班，
        </el-form-item>
        <el-form-item label="每天工作"
                      prop="workTime">
          <el-select v-model="form['form6'].workTime"
                     placeholder="请选择"
                     style="width:100px">
            <el-option v-for="item in hourList"
                       :key="item"
                       :label="item"
                       :value="item"></el-option>
          </el-select>
          小时，
        </el-form-item>
        <el-form-item label="每周休息"
                      prop="rest">
          <el-select v-model="form['form6'].rest"
                     placeholder="请选择"
                     style="width:100px">
            <el-option v-for="item in weekList"
                       :key="item"
                       :label="item"
                       :value="item"></el-option>
          </el-select>
          天。
        </el-form-item>
      </el-form-item>
      <el-form-item label="其他说明："
                    prop="otherExplain"
                    v-if="form['form6'].agreeApplicant === false">
        <el-input v-model="form['form6'].otherExplain"
                  type="textarea"
                  :rows="5"
                  :maxlength="600"
                  style="width:700px"></el-input>
      </el-form-item>
    </el-form>
    <!-- ---------社保缴纳情况?--------- -->
    <el-form :inline="true"
             :disabled="submitStatus === 2"
             ref="form7"
             :rules="rules['form7']"
             :model="form['form7']"
             v-if="answerType === 'form7'">
      <el-form-item v-if="isRespondent"
                    prop="agreeApplicant"
                    label="是否同意申请人回答内容">
        <el-radio-group v-model="form['form7'].agreeApplicant"
                        style="width: 200px">
          <el-radio :label="'1'">是</el-radio>
          <el-radio :label="'0'">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form['form7'].agreeApplicant === '0'">
        <el-form-item prop="code">
          <el-select v-model="form['form7'].code"
                     placeholder="请选择"
                     style="width:140px">
            <el-option v-for="item in socialInsuranceList"
                       :key="item.code"
                       :label="item.title"
                       :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="其它说明"
                      prop="otherExplain">
          <el-input v-model="form['form7'].otherExplain"
                    :maxlength="600"
                    style="width:600px"></el-input>
        </el-form-item>
      </el-form-item>
    </el-form>
    <!-- ---------某期间的工资发放情况？--------- -->
    <el-form :model="form['form8']"
             :disabled="submitStatus === 2"
             ref="form8"
             :rules="rules['form8']"
             v-if="answerType === 'form8'">
      <el-form-item v-if="isRespondent"
                    prop="agreeApplicant"
                    label="是否同意申请人回答内容">
        <el-radio-group v-model="form['form8'].agreeApplicant"
                        style="width: 200px">
          <el-radio :label="'1'">是</el-radio>
          <el-radio :label="'0'">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="time"
                    v-if="form['form8'].agreeApplicant === '0'">
        <el-date-picker v-model="form['form8'].time"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="width:320px">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="explain"
                    v-if="form['form8'].agreeApplicant === '0'">
        <el-input v-model="form['form8'].explain"
                  type="textarea"
                  :rows="5"
                  :maxlength="600"
                  style="width:800px"></el-input>
      </el-form-item>
    </el-form>
    <!-- ---------最后工作日？--------- -->
    <el-form :model="form['form9']"
             :disabled="submitStatus === 2"
             ref="form9"
             :rules="rules['form9']"
             v-if="answerType === 'form9'">
      <el-form-item v-if="isRespondent"
                    prop="agreeApplicant"
                    label="是否同意申请人回答内容">
        <el-radio-group v-model="form['form9'].agreeApplicant"
                        style="width: 200px">
          <el-radio :label="'1'">是</el-radio>
          <el-radio :label="'0'">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="time"
                    v-if="form['form9'].agreeApplicant === '0'">
        <el-date-picker v-model="form['form9'].time"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                        style="width: 150px">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <!-- ---------何时解除劳动关系，解除原因--------- -->
    <el-form :inline="true"
             :disabled="submitStatus === 2"
             ref="form10"
             :rules="rules['form10']"
             :model="form['form10']"
             v-if="answerType === 'form10'">
      <el-form-item v-if="isRespondent"
                    prop="agreeApplicant"
                    label="是否同意申请人回答内容">
        <el-radio-group v-model="form['form10'].agreeApplicant"
                        style="width: 200px">
          <el-radio :label="'1'">是</el-radio>
          <el-radio :label="'0'">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form['form10'].agreeApplicant === '0'">
        <el-form-item prop="remove">
          <el-radio-group v-model="form['form10'].remove"
                          style="width: 170px">
            <el-radio :label="true">解除</el-radio>
            <el-radio :label="false">未解除</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="解除时间"
                      v-if="form['form10'].remove"
                      prop="time">
          <el-date-picker v-model="form['form10'].time"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期"
                          style="width: 150px">
          </el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item label="原因"
                    v-if="form['form10'].remove && form['form10'].agreeApplicant === false"
                    prop="reason">
        <el-input v-model="form['form10'].reason"
                  type="textarea"
                  style="width:800px"
                  :maxlength="600"
                  :rows="5"></el-input>
      </el-form-item>
    </el-form>
    <!-- ---------是否愿意调解？--------- -->
    <el-form :model="form['form12']"
             :disabled="submitStatus === 2"
             ref="form12"
             :rules="rules['form12']"
             v-if="answerType === 'form12'">
      <el-form-item prop="code">
        <el-select v-model="form['form12'].code"
                   placeholder="请选择"
                   style="width:100px">
          <el-option v-for="item in mediateList"
                     :key="item.code"
                     :label="item.title"
                     :value="item.code"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { setStore, getStore, isElementNotInViewport } from "@/utils/utils.js";
export default {
  props: {
    questionType: Number,
    answerContent: String,
    // 提交状态，默认等于2 不能编辑。
    submitStatus: false,
  },
  watch: {
    questionType: {
      immediate: true,
      handler(value) {
        console.log(value, 'hedahai q23213')
        // if (value === 20) {
        //   // 最后陈述意见  特殊处理
        //   this.answerType = 'form0'
        // } else {
        // 代理人身份回答问题模板全为输入框
        let loginInfo = JSON.parse(getStore("loginInfo"));
        if (loginInfo.personType === "STAFF") {
          this.memberType = "MEDIATOR";
        } else {
          this.memberType = loginInfo.memberType;
        }
        if (this.memberType === 'RESPONDENT_AGENT' || this.memberType === 'APPLICANT_AGENT') {
          if (value == 20 || value == 12) { 
            this.answerType = 'formAgent12'
          } else if (value == 21) {
            this.answerType = 'form20'
          }else if (value == 22) {
            this.answerType = 'formAgent12'
          } else {
            this.answerType = 'formAgent'
          }

          if (value === 1) {
            this.textAreaPlaceHolder = '入职时间__工作岗位__'
          } else if (value === 4) {
            this.textAreaPlaceHolder = '每月__日以__形式发放__工资'
          } else if (value === 5) {
            this.textAreaPlaceHolder = '(有/无)工资清单，（是/否）需要签收。'
          } else if (value === 6) {
            this.textAreaPlaceHolder = '早上__点上班，下午__点下班，每天工作__小时，每周休息__天，其他说明__'
          } else if (value === 8) {
            this.textAreaPlaceHolder = '__时间至__时间'
          } else if (value === 10) {
            this.textAreaPlaceHolder = '（解除/未解除），解除时间__，解除原因__'
          } else {
            this.textAreaPlaceHolder = ''
          }
        } else {
          if (value == 21) {
            this.answerType = 'form20' 
          }else if(value == 22){
            this.answerType = 'formAgent12'
          } else {
            this.answerType = 'form' + value
          }
        }
        if (this.memberType === 'RESPONDENT_AGENT' || this.memberType === 'RESPONDENT') {
          this.isRespondent = true
        } else {
          this.isRespondent = false
          // 历史数据容错处理
          this.form[this.answerType].agreeApplicant = '0'
        }
        console.log(value, this.answerType, this.memberType)
      }
    },
    answerContent: {
      immediate: true,
      handler(value) {
        if (value) {
          console.log(value, this.answerType, 'answerContent字段监听')
          this.form[this.answerType] = JSON.parse(value)
        }
      }
    },
    submitStatus: {
      immediate: true,
      handler(value) {
        console.log('submitStatus', value)
      }
    }
  },

  data() {
    var textFieldCheck = (rule, value, callback) => {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入文字'))
      } else {
        callback()
      }
    }
    var selectFieldCheck = (rule, value, callback) => {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请选择'))
      } else {
        callback()
      }
    }
    return {
      memberType: '',
      isRespondent: true,
      answerType: '',
      form: {
        'formAgent': { text: '', agreeApplicant: '' },
        'formAgent12': { text: '', agreeApplicant: '' },
        'form0': { text: '', agreeApplicant: '' },
        'form20': { text: '' },
        // 入职时间？工作岗位？
        'form1': { time: '', position: '' },
        // 签订劳动合同情况？
        'form2': { code: '' },
        // 工资何时、何形式发放？
        'form4': { dayCode: '', transferMoneyCode: '', monthCode: '' },
        // 发放工资是否有工资清单？是否需要签收？
        'form5': { salary: '', sign: '' },
        // 工作时间？
        'form6': { upWork: '', downWork: '', workTime: '', rest: '', otherExplain: '' },
        // 社保缴纳情况?
        'form7': { code: '', otherExplain: '' },
        // 某期间的工资发放情况？
        'form8': { time: [], explain: '' },
        // 最后工作日？
        'form9': { time: '' },
        // 何时解除劳动关系，解除原因?
        'form10': { remove: '', time: '', reason: '' },
        // 是否愿意调解？
        'form12': { code: '' }
      },
      rules: {
        'formAgent': {
          text: [{ validator: textFieldCheck, trigger: 'blur' }],
          agreeApplicant: [{ validator: selectFieldCheck, trigger: 'change' }]
        },
        'formAgent12': {
          text: [{ validator: textFieldCheck, trigger: 'blur' }],
          agreeApplicant: [{ validator: selectFieldCheck, trigger: 'change' }]
        },
        'form0': {
          text: [{ validator: textFieldCheck, trigger: 'blur' }],
          agreeApplicant: [{ validator: selectFieldCheck, trigger: 'change' }]
        },
        // 最后陈述意见为选填
        'form20': {
          text: [{ required: false, trigger: 'blur' }]
        },
        'form1': {
          time: [{ validator: selectFieldCheck, trigger: 'change' }],
          position: [{ validator: textFieldCheck, trigger: 'blur' }],
          agreeApplicant: [{ validator: selectFieldCheck, trigger: 'change' }]
        },
        'form2': {
          code: [{ validator: selectFieldCheck, trigger: 'change' }],
        },
        'form4': {
          dayCode: [{ validator: selectFieldCheck, trigger: 'change' }],
          transferMoneyCode: [{ validator: selectFieldCheck, trigger: 'change' }],
          monthCode: [{ validator: selectFieldCheck, trigger: 'change' }]
        },
        'form5': {
          salary: [{ validator: selectFieldCheck, trigger: 'change' }],
          sign: [{ validator: selectFieldCheck, trigger: 'change' }]
        },
        'form6': {
          upWork: [{ validator: selectFieldCheck, trigger: 'change' }],
          downWork: [{ validator: selectFieldCheck, trigger: 'change' }],
          workTime: [{ validator: selectFieldCheck, trigger: 'change' }],
          rest: [{ validator: selectFieldCheck, trigger: 'change' }],
          // otherExplain: [{ validator: textFieldCheck, trigger: 'blur' }]
        },
        'form7': {
          code: [{ validator: selectFieldCheck, trigger: 'change' }],
          // otherExplain: [{ validator: textFieldCheck, trigger: 'blur' }]
        },
        'form8': {
          time: [{ validator: selectFieldCheck, trigger: 'change' }],
          explain: [{ validator: textFieldCheck, trigger: 'blur' }]
        },
        'form9': {
          time: [{ validator: selectFieldCheck, trigger: 'change' }]
        },
        'form10': {
          remove: [{ validator: selectFieldCheck, trigger: 'change' }],
          time: [{ validator: selectFieldCheck, trigger: 'change' }],
          reason: [{ validator: textFieldCheck, trigger: 'blur' }]
        },
        'form12': {
          code: [{ validator: selectFieldCheck, trigger: 'change' }]
        }
      },
      textAreaPlaceHolder: '',
      // 劳动合同list 
      laborContractList: [
        { code: 1, title: '有签订劳动合同' },
        { code: 2, title: '无签订劳动合同' }
      ],
      // 转账方式
      transferMoneyList: [
        { code: 1, title: '银行转账' },
        { code: 2, title: '微信转账' },
        { code: 3, title: '支付宝转账' },
        { code: 4, title: '现金' }
      ],
      // 1~30
      dayList: [],
      // 1~12
      hourList: [],
      weekList: [],
      monthList: [
        { code: 1, title: '上月' },
        { code: 2, title: '本月' },
      ],
      socialInsuranceList: [
        { code: 1, title: '有缴纳社保' },
        { code: 2, title: '没有缴纳社保' }
      ],
      mediateList: [
        { code: 1, title: '愿意' },
        { code: 2, title: '不愿意' }
      ]
    }
  },

  created() {
    this.dayListInit()
    this.hourListInit()
    this.weekListInit()
  },
  methods: {
    getCurrentForm() {
      let that = this
      // 首先判断是否可以保存,如果信息不完善不能保存
      return new Promise((resolve, reject) => {
        console.log('当前表单类型form' + this.answerType)
        this.$refs[this.answerType].validate((valid) => {
          if (valid) {
            let answerContent = this.form[this.answerType]
            let text = this.spliceFormToShowText()
            const reg = require('./RGI_Emoji.js')()
            if(reg.test(text)){
              reject('系统暂不支持emoji表情')
            }
            
            if(text.indexOf('&') != -1  || text.indexOf('#') != -1 || text.indexOf('$') != -1){
              reject('含有特殊符号')
            }
            if (this.isRespondent === false || this.answerType === 'formAgent12' || this.answerType === 'form12' || this.answerType === 'form20') {
              answerContent.agreeApplicant = '0'
            }
            answerContent.text = text
            console.log(answerContent)
            resolve(JSON.stringify(answerContent))
          } else {
            console.log('校验失败', this.answerType)
            reject('答案不全')
          }
        })
      })
    },
    //一键保存的时候跳过校验
    getCurrentForm1() {
        let that = this
      // 首先判断是否可以保存,如果信息不完善不能保存
      return new Promise((resolve, reject) => {
           let answerContent = this.form[this.answerType]
           let text = this.spliceFormToShowText()
            if (this.isRespondent === false || this.answerType === 'formAgent12' || this.answerType === 'form12' || this.answerType === 'form20') {
              answerContent.agreeApplicant = '0'
            }
            answerContent.text = text
            resolve(JSON.stringify(answerContent))
      })
    },
    // 答案拼接为可以展示的字段
    spliceFormToShowText() {
      let form = this.form[this.answerType]
      let text = ''
      console.log(this.memberType, '=--------')
      if (this.answerType === 'form0' || this.answerType === 'form3' || this.answerType === 'form11' || this.answerType === 'formAgent' || this.answerType === 'formAgent12') {
        // 无须转换
        text = form.text
      } else if (this.answerType === 'form20') {
        if (form.text.length) {
          text = form.text
        } else {
          text = ''
        }
      } else if (this.answerType === 'form1') {
        text = `入职时间${this.timeConvert(form.time)}，工作岗位是${form.position}。`
      } else if (this.answerType === 'form2') {
        this.laborContractList.map(item => {
          if (item.code === form.code) {
            text = item.title
          }
        })
      } else if (this.answerType === 'form4') {
        // 工资何时、何形式发放？
        // 'form4': { dayCode: '', transferMoneyCode: '', monthCode: '' },
        let transferMoneyTitle = ''
        this.transferMoneyList.map(item => {
          if (item.code === form.transferMoneyCode) {
            transferMoneyTitle = item.title
          }
        })
        let monthTitle = ''
        this.monthList.map(item => {
          if (item.code === form.monthCode) {
            monthTitle = item.title
          }
        })
        text = `每月${form.dayCode}日以${transferMoneyTitle}形式发放${monthTitle}工资。`
      } else if (this.answerType === 'form5') {
        text = `${form.salary ? '' : '没'}有工资清单, ${form.sign ? '' : '不'}需要签收。`
      } else if (this.answerType === 'form6') {
        text = `早上${form.upWork}点上班，下午${form.downWork}点下班，每天工作${form.workTime}小时，每周休息${form.rest}天。其他说明:${form.otherExplain}。`
      } else if (this.answerType === 'form7') {
        let socialInsurance = ''
        this.socialInsuranceList.map(item => {
          if (item.code === form.code) {
            socialInsurance = item.title
          }
        })
        text = `${socialInsurance},其他说明${form.otherExplain}。`
      } else if (this.answerType === 'form8') {
        text = `${this.timeConvert(form.time[0])}至${this.timeConvert(form.time[1])},${form.explain}。`
      } else if (this.answerType === 'form9') {
        text = `${this.timeConvert(form.time)}`
      } else if (this.answerType === 'form10') {
        if (form.remove) {
          text = `解除，解除时间：${this.timeConvert(form.time)},解除原因：${form.reason}。`
        } else {
          text = '未解除。'
        }
      } else if (this.answerType === 'form12') {
        let mediate = ''
        this.mediateList.map(item => {
          if (item.code === form.code) {
            mediate = item.title
          }
        })
        text = `${mediate}。`
      } else {
        text = '模板错误'
      }
      console.log(this.isRespondent)
      console.log(form)
      console.log(form.agreeApplicant)
      if (this.isRespondent && form.agreeApplicant === '1' && this.answerType != 'formAgent12') {
        text = '确认。'
      }
      console.log(text, form)
      return text
    },
    // 时间戳格式转化，转化为固定格式
    timeConvert(formatTimeString) {
      return formatTimeString
      // let d = new Date(formatTimeString)
      // console.log(d.getFullYear().toString())
      // console.log((d.getMonth() + 1).toString())
      // console.log(d.getDate().toString())
      // return `${d.getFullYear().toString()}-${(d.getMonth() + 1).toString()}-${d.getDate().toString()}`
    },

    // 初始化每月天数选择数据
    dayListInit() {
      for (let index = 1; index < 31; index++) {
        this.dayList.push(index)
      }
    },
    // 初始化时间选择器 
    hourListInit() {
      for (let index = 1; index < 13; index++) {
        this.hourList.push(index)
      }
    },
    weekListInit() {
      for (let index = 1; index < 8; index++) {
        this.weekList.push(index)
      }
    }
  }
};
</script>

 <style lang="scss" scoped>
.answer-form {
  margin-left: 40px;
}
/deep/ .el-select-dropdown__list {
  height: 80px;
}
</style>
